// src/pages/Feed.js
import React from "react";
import PostFeed from "../components/PostFeed";

export default function Feed() {
  return (
    <>
      <PostFeed />
    </>
  );
}
